import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventPageComponent } from './event-page/event-page.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../routing/app-routing.module';
import { AgmCoreModule } from '@agm/core';
import { AppMaterialModule } from '../app-material.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import {
  MatButtonModule,
  MatDatepickerModule,
  MatExpansionModule,
  MatInputModule, MatNativeDateModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule
} from '@angular/material';
import { AviationEventsService } from '../shared/services/aviation-events.service';
import { EventDetailComponent } from './event-detail/event-detail.component';
import { EventOverviewComponent } from './event-overview/event-overview.component';
import { EventAddFormComponent } from './event-add-form/event-add-form.component';
import { EventDescriptionComponent } from './event-description/event-description.component';
import { EventLocationComponent } from './event-location/event-location.component';
import { EventDetailsComponent } from './event-details/event-details.component';
import { EventContactComponent } from './event-contact/event-contact.component';
import { EditEventDescriptionComponent } from './edit-event-description/edit-event-description.component';
import { EditEventNameComponent } from './edit-event-name/edit-event-name.component';
import { EventShortDescriptionComponent } from './event-short-description/event-short-description.component';
import { EditEventShortDescriptionComponent } from './edit-event-short-description/edit-event-short-description.component';
import { EditEventDetailsComponent } from './edit-event-details/edit-event-details.component';
import { EditEventContactComponent } from './edit-event-contact/edit-event-contact.component';
import { EditEventLocationComponent } from './edit-event-location/edit-event-location.component';
import { EditEventImageComponent } from './edit-event-image/edit-event-image.component';
import { DeleteEventImageComponent } from './delete-event-image/delete-event-image.component';
import { DeleteEventComponent } from './delete-event/delete-event.component';
import { EventFeaturesComponent } from './event-features/event-features.component';
import { EditEventFeaturesComponent } from './edit-event-features/edit-event-features.component';
import { CloneEventComponent } from './clone-event/clone-event.component';
import { NgxGalleryModule } from 'ngx-gallery';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AgmCoreModule,
        AppMaterialModule,
        MatGridListModule,
        MatRadioModule,
        MatExpansionModule,
        MatButtonModule,
        MatSortModule,
        MatTableModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxGalleryModule
    ],
  declarations: [
    EventPageComponent,
    EventDetailComponent,
    EventOverviewComponent,
    EventAddFormComponent,
    EventDescriptionComponent,
    EventLocationComponent,
    EventDetailsComponent,
    EventContactComponent,
    EditEventDescriptionComponent,
    EditEventNameComponent,
    EventShortDescriptionComponent,
    EditEventShortDescriptionComponent,
    EditEventDetailsComponent,
    EditEventContactComponent,
    EditEventLocationComponent,
    EditEventImageComponent,
    DeleteEventImageComponent,
    DeleteEventComponent,
    EventFeaturesComponent,
    EditEventFeaturesComponent,
    CloneEventComponent
  ],
  providers: [
    AviationEventsService
  ],
  entryComponents: [
    EditEventDescriptionComponent,
    EditEventNameComponent,
    EditEventShortDescriptionComponent,
    EditEventDetailsComponent,
    EditEventContactComponent,
    EditEventLocationComponent,
    EditEventImageComponent,
    DeleteEventImageComponent,
    DeleteEventComponent,
    EditEventFeaturesComponent,
    CloneEventComponent
  ]
})
export class EventModule { }
